'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bulletin-list', {
      url: '/bulletin/list',
      template: '<bulletin-list></bulletin-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/list/general/bulletin-list.routes.js